var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PagePicker',{attrs:{"page-id":_vm.pageId,"parent-id":_vm.parentId,"is-copying":_vm.copying,"is-moving":_vm.moving},on:{"copy":_vm.onCopy,"move":_vm.onMove,"close":_vm.onClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }